import { render, staticRenderFns } from "./geometry-drawer.vue?vue&type=template&id=236a89e0&scoped=true&"
import script from "./geometry-drawer.vue?vue&type=script&lang=ts&"
export * from "./geometry-drawer.vue?vue&type=script&lang=ts&"
import style0 from "./geometry-drawer.vue?vue&type=style&index=0&id=236a89e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a89e0",
  null
  
)

export default component.exports